import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Carnet from '../components/Carnet.vue'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;


        this.app = createApp({
            template: '<Carnet />',
            components: {
                Carnet
            },
            data() {
                return {
                    //
                }
            },
            mounted() {
            },
        })
        this.app.config.globalProperties.emitter = emitter;
        this.app.mount(self.el)
    }

    destroy() {
        this.app.unmount();
    }
}